export default __webpack_public_path__ + "static/media/ic_uni_24.47e903f7.svg";